//CHECKED
import React, { Fragment } from "react";
import styled from "styled-components";
import lang from "../functions/lang";
import DirectionsIconWhite from "./Icons/DirectionsIconWhite";

const HeaderTitleContainer = styled.div`
  width: 100%;
  align-items: flex-start;
  display: flex;
  flex-flow: column;
  background-color: #522398;
`;

const FindLocationHeader = styled.h3`
  margin-top: 17px;
  margin-bottom: 11px;
  padding: 0 0.8rem;
  color: #f2f0f0;
  font-size: 22px;
`;

const FindLocationContainer = styled.div``;

const SloganMessage = styled.div`
  padding: 1.2rem 1.2rem;
  font-size: 14px;
  font-weight: 800;
  color: #522398;
  letter-spacing: -0.2px;
`;

const HeaderTitleFlexContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1.5rem;
`;

const MapIconImage = styled.div`
  width: 13.5px;
  height: 18.02px;
  margin-top: 2px;
`;

export const Title = () => {
  return (
    <Fragment>
      <HeaderTitleContainer>
        <FindLocationContainer>
          <HeaderTitleFlexContainer>
            <DirectionsIconWhite />

            <FindLocationHeader>
              {lang("modal.find_a_location", window.data?.language || "en")}
            </FindLocationHeader>
          </HeaderTitleFlexContainer>
        </FindLocationContainer>
      </HeaderTitleContainer>
      <SloganMessage>
        {lang("modal.slogan", window.data?.language || "en")}
      </SloganMessage>
    </Fragment>
  );
};
